import React from 'react'

import chatbotLogo from 'Logos/Chatbot_Logo.svg?url'

import styles from './OnboardingHeader.module.css'

const OnboardingHeader = () => {
  return (
    <div className={styles.OnboardingProcessHeader}>
      <div className={styles.CompanyLogoGroup}>
        <img src={chatbotLogo} alt='Chatbot' className={styles.ChatbotLogo} />
      </div>
    </div>
  )
}

export default OnboardingHeader
